import styled from "styled-components"
import { device } from "breakpoints"
import quoteMark from "icons/quoteMark.svg"

export const ContentWrapper = styled.div`

  >h1,
  >h2,
  >h3,
  >h4,
  >h5,
  >h6 {
    font-weight: normal;
    margin-top:35px;


    @media ${device.desktop} {
      margin-top:47px;
    }
  }

  >h1 {
    font-size: 24px;
    margin-bottom: 14px;
    @media ${device.desktop} {
      font-size: 36px;
      margin-bottom: 17px;

    }
  }



  >h2 {
    font-size: 22px;
    margin-bottom: 17px;
    @media ${device.desktop} {
      font-size: 28px;

    }
  }

  >h3 {
    font-size: 18px;
    margin-bottom: 10px;

    @media ${device.desktop} {
      font-size: 24px;
      margin-bottom: 17px;
    }
  }

  >h4 {
    font-size: 16px;
    margin-bottom: 12px;

    @media ${device.desktop} {
      font-size: 20px;
      margin-bottom: 16px;

    }
  }

  >h5,>h6 {
    font-size: 15px;
    margin-bottom:7px;
    margin-top:0;
    @media ${device.desktop} {
    font-size: 18px;
    }

    strong {
      font-weight: bold;
      color:#646F77;
    }
  }

  strong {
    font-weight: 500;
    color:#313B44;
  }

  >p.highlighted {
    font-size: 18px;
    color:#007E8F;
    margin-bottom:17px;
    @media ${device.desktop} {
    font-size: 24px;
    margin-bottom:27px;

    }
  }

  > p, li {
    font-size: 15px;
    @media ${device.desktop} {
      font-size: 18px;
    }

    a {
      display: inline-block;
      position: relative;
      color: #008973;
      font-weight: 500;
      background-image: linear-gradient(to right, #32BDA3, #32BDA3);
      background-position: 0 85%;
      background-repeat: no-repeat;
      background-size: 100% 0px;

      :hover {
        color:#32BDA3;
        background-size: 100% 1px;
      }
    }
  }

  > p {
    margin-bottom: 28px;
    @media ${device.desktop} {
      margin-bottom: 30px;
    }

 
  }

  > ul {
    margin-left: 18px;
    margin-bottom: 25px;
    margin-top: 25px;

    @media ${device.desktop} {
      margin-left: 27px;
      margin-bottom: 35px;
      margin-top: 35px;
    }

    >li {
      margin-bottom:18px;
      :last-of-type{
        margin:0;
        }
    }
  }
  
  > ul {
    list-style: none;
    > li {
    position: relative;
      ::before {
        content: "";
        height: 6px;
        width: 6px;
        background-color: #42BBA3;
        display: block;
        border-radius: 50%;
        position: absolute;
        top: 7px;
        left: -18px;

        @media ${device.desktop} {
        top: 9px;
        left: -24px;

        }
      }
    }
  }



  h6 {
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 15px;
    margin-top:30px;

    @media ${device.desktop} {
      margin-bottom: 20px;
      font-size: 16px;

    }
  }

  > ol {
    margin-left: 17px;
    li {
      margin-bottom: 17px;
      font-size: 14px;
      @media ${device.desktop} {
      font-size: 16px;
    }
    }
  }



/* ol with numbers + dots */

/* > ol {
    list-style: none;
   counter-reset:counter;
    > li {
    counter-increment: counter;
    position: relative;
      ::before {
        content: counter(counter) ".";
        position: absolute;
        left: -18px;
        top: 0;
        font-weight: 500;
        color: ${(props) => props.theme.primaryColor};

        @media ${device.desktop} {
        left:-24px;
        }
      }
    }
} */

/* ol with numbers + circle */

  /* > ol {
    counter-reset:counter;
    margin-left:40px;
    @media ${device.desktop} {
    margin-left:46px;
    }
    > li {
      counter-increment: counter;
      position: relative;
      ::before {
        content: counter(counter);
        position: absolute;
        top: 0;
        left: -40px;
        height: 30px;
        width: 30px;
        border: 2px solid ${(props) => props.theme.primaryColor};
        text-align: center;
        font-weight: bold;
        border-radius: 25px;
        color: ${(props) => props.theme.primaryColor};
        line-height:24px;
        font-size:20px;

        @media ${device.desktop} {
        left:-46px;
        }
      }
    }
  } */

  figure {
    width: 100%;
    margin: 0 auto;

    &.alignleft {
      float: left;
      margin-left: 0;
      width: 35%;
      margin-right: 20px;
      margin-bottom:20px;
    }

    &.alignright {
      float: right;
      margin-right: 0;
      width: 35%;
      margin-left: 20px;
      margin-bottom:20px;   
    }

    @media ${device.tablet} {
      &.alignwide,
      &.alignfull {
        margin-left: 0;
        width: 100%;
      }

      &.alignleft {
        margin-right: 40px;
        margin-bottom: 40px;
      }

      &.alignright {
        margin-left: 40px;
        margin-bottom:40px;   
      }
    }
  }

  figure.wp-block-image {
    margin-top: 30px;
    margin-bottom: 30px;
    padding-top:66.66666666%;
    position:relative;
    @media ${device.desktop} {
      margin-bottom: 55px;
      margin-top: 55px;
    }

    img {
      display: block;
      position:absolute;
      top:0;
      left:0;
      width: 100%;
      height:100%;
    }

    figcaption {
      margin-top:10px;
    }
  }

  > blockquote {
    margin: 40px 0 30px 0;
    position: relative;
    padding-left: 46px;
    border-bottom:2px solid #4EA3B3;
    padding-bottom:30px;

    @media ${device.desktop} {
      padding-left:85px;
      padding-bottom:50px;
      margin: 50px 0 60px 0;

    }

    :before {
      content: "";
      position: absolute;
      height: 25px;
      width: 28px;
      background-image: url('${quoteMark}');
      background-size: 100%;
      background-repeat: no-repeat;
      display: block;
      top: 0;
      left: 0;

      @media ${device.desktop} {
      height:45px;
      width:54px;
      top:-18px;
      }
    }

    p {
      font-size: 22px;
      margin-left: 0;
      color:#1B7E8D;
      line-height:130%;
      @media ${device.desktop} {
      font-size: 28px;
      margin-top:20px;

      }
    }

    cite {
      font-size: 12px;
      color: #656F76;
      margin-top:15px;
      position: relative;
      font-style: normal;
      display:block;

      @media ${device.desktop} {
        font-size: 14px;
        margin-top:20px;
      }
      ::before {
        content: "";
        position: absolute;
        height: 1px;
        width: 10px;
        top: 7px;
        left: -17px;
        background-color: #656F76;
        @media ${device.desktop} {
          top:9px;
        }
      }
    }
  }
  
  /* video embed */
  figure.is-type-video {
    margin:40px 0;
    .wp-block-embed__wrapper {
      position: relative;
      padding-bottom: 56.25%;

      iframe {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }
    }
  }
`
